var map = {
	"./assets/clickable/upwork.svg": "24c861239e850349d429",
	"./assets/disabled/upwork.svg": "89d43088f6f0fee9abf2",
	"./assets/original/upwork.svg": "02ed85db386b40f0bc2f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "642ffe055fa276b75805";